// // import * as angular from 'angular';
// declare var google: any;

export function MapDirective() {
  return {
    scope: {},
    bindToController: {
      lat: '@',
      lng: '@',
      zoom: '@',
      items: '=',
    },
    restrict: 'E',
    transclude: true,
    replace: true,
    template: '<div></div>',
    controller: MapController,
    controllerAs: 'vm',
  };
}

MapController.$inject = ['$scope', '$element', '$attrs', 'GoogleMapService'];

function MapController($scope, $element, $attrs, GoogleMapService) {
  var vm = this;

  var map, infoWindow;
  var markers = [];

  vm.$onInit = function () {
    // Check if latitude and longitude are specified
    if (angular.isDefined(vm.lat) && angular.isDefined(vm.lng)) {
      // Loads google map script
      GoogleMapService.loadGoogleMapScript.then(function () {
        var option = $attrs.option || '';

        if (!option) {
          initializeMap('', '', '');
          $scope.$watch('lat+lng+zoom', function () {
            if (vm.lat) {
              initializeMap(vm.lat, vm.lng, vm.zoom);
            }
          });
        } else {
          // broadcast from controller
          var removeListener = $scope.$on('reloadItems', function ($event, data) {
            initializeMapMultiple(data, vm.zoom);
          });

          // Remove listener
          $scope.$on('$destroy', removeListener);

          if (removeListener) {
            // First load
            initializeMapMultiple(vm.items, vm.zoom);
          }
        }
      });
    }
  };

  var initializeMap = function (latParams, lngParams, zoomParams) {
    var geoLat = latParams ? latParams : 9.96271896977588;
    var geoLng = lngParams ? lngParams : -84.1387939453125;
    var geoZoom = zoomParams ? zoomParams : 4;

    var mapOptions = {
      center: new google.maps.LatLng(geoLat, geoLng),
      zoom: parseInt(geoZoom),
      mapTypeId: google.maps.MapTypeId.ROADMAP, //,
      //scrollwheel: false
    };

    // Create the map
    map = new google.maps.Map($element[0], mapOptions);

    // Add currrent marker
    if (latParams) {
      var coordinates = new google.maps.LatLng(geoLat, geoLng);
      addMarker(map, coordinates);
    }

    // Create the search box and link it to the UI element.
    var input = document.getElementById('pac-input');

    if (input === null) {
      return false;
    }

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    var searchBox = new google.maps.places.SearchBox(input);

    google.maps.event.addListener(searchBox, 'places_changed', function () {
      var places = searchBox.getPlaces();

      var i, marker;

      if (places.length === 0) {
        return;
      }

      for (i = 0; markers[i]; i++) {
        marker = markers[i];
        marker.setMap(null);
      }

      // For each place, get the icon, place name, and location.
      var searchZoom = '11';
      markers = [];
      var bounds = new google.maps.LatLngBounds();
      var place;
      for (i = 0; places[i]; i++) {
        place = places[i];

        var image = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25),
        };

        // Create a marker for each place.
        var markerPlace = new google.maps.Marker({
          map: map,
          icon: image,
          title: place.name,
          position: place.geometry.location,
        });

        var searchLat = map.getBounds().getNorthEast().lat();
        var searchLng = map.getBounds().getNorthEast().lng();

        // var geo_lat = <HTMLInputElement>document.getElementById('geo_lat');
        // var geo_lng = <HTMLInputElement>document.getElementById('geo_lng');
        // var geo_zoom = <HTMLInputElement>document.getElementById('geo_zoom');

        // geo_lat.value = searchLat;
        // geo_lng.value = searchLng;
        // geo_zoom.value = searchZoom;

        geo_lat.value = document.getElementById('geo_lat');
        geo_lng.value = document.getElementById('geo_lng');
        geo_zoom.value = document.getElementById('geo_zoom');

        markers.push(markerPlace);

        bounds.extend(place.geometry.location);
      }

      map.fitBounds(bounds);
      map.setZoom(searchZoom);
      //map.setCenter(center); //Gives me an error
    });
    // [END region_getplaces]

    // Bias the SearchBox results towards places that are within the bounds of the
    // current map's viewport.
    google.maps.event.addListener(map, 'bounds_changed', function () {
      var bounds = map.getBounds();
      searchBox.setBounds(bounds);
    });

    //Get the coordinates to the input element
    google.maps.event.addListener(map, 'click', function (event) {
      document.getElementById('geo_lat').value = event.latLng.lat();
      document.getElementById('geo_lng').value = event.latLng.lng();
      document.getElementById('geo_zoom').value = map.getZoom();

      // var geo_lat = <HTMLInputElement>document.getElementById('geo_lat');
      // var geo_lng = <HTMLInputElement>document.getElementById('geo_lng');
      // var geo_zoom = <HTMLInputElement>document.getElementById('geo_zoom');

      // geo_lat.value = event.latLng.lat();
      // geo_lng.value = event.latLng.lng();
      // geo_zoom.value = map.getZoom();

      deleteMarkers();
      addMarker(map, event.latLng);
    });

    google.maps.event.addListener(map, 'mousemove', function (event) {
      document.getElementById('latspan').innerHTML = event.latLng.lat();
      document.getElementById('lngspan').innerHTML = event.latLng.lng();
      document.getElementById('zoomspan').innerHTML = map.getZoom();
    });

    function addMarker(map, position) {
      var marker;
      var markerOptions = {
        position: position,
        map: map,
        icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
      };

      marker = new google.maps.Marker(markerOptions);
      markers.push(marker);
    }

    // Sets the map on all markers in the array.
    function setAllMap(map) {
      for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
      }
    }

    // Removes the markers from the map, but keeps them in the array.
    function clearMarkers() {
      setAllMap(null);
    }

    // Shows any markers currently in the array.
    function showMarkers() {
      setAllMap(map);
    }

    // Deletes all markers in the array by removing references to them.
    function deleteMarkers() {
      clearMarkers();
      markers = [];
    }
  };

  var initializeMapMultiple = function (items, zoom) {
    var map = new google.maps.Map(document.getElementById('map'), {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    var infowindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();

    var marker, i;
    for (i = 0; i < items.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(items[i][1], items[i][2]),
        map: map,
        icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
      });

      bounds.extend(marker.position);

      google.maps.event.addListener(
        marker,
        'click',
        (function (marker, i) {
          return function () {
            infowindow.setContent(items[i][0]);
            infowindow.open(map, marker);
          };
        })(marker, i)
      );
    }

    map.fitBounds(bounds);

    var listener = google.maps.event.addListener(map, 'idle', function () {
      map.setZoom(parseInt(zoom));
      google.maps.event.removeListener(listener);
    });
  };
}
